import { render, staticRenderFns } from "./TicketDetailsIcons.vue?vue&type=template&id=61576e38&"
import script from "./TicketDetailsIcons.vue?vue&type=script&lang=js&"
export * from "./TicketDetailsIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports